export const Pagination = ({ currentPage, maxPage, onGoBack, onNext }) => {
  const isPrevDisabled = currentPage === 1;
  const isNextDisabled = currentPage === maxPage;

  const disabledColor = 'grey';
  const activeColor = '#fff';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingRight: 10,
      }}
    >
      <button
        style={{
          color: isPrevDisabled ? disabledColor : activeColor,
          backgroundColor: 'transparent',
          border: 'none',
          fontSize: '1.3rem',
          padding: 8,
          fontWeight: 'bold',
        }}
        onClick={onGoBack}
        disabled={isPrevDisabled}
      >
        &#60;
      </button>
      <span
        style={{
          fontSize: '1.2rem',
          fontWeight: 'bold',
          padding: 8,
          color: '#fff',
          height: 40,
          boxSizing: 'border-box',
        }}
      >
        {currentPage} / {maxPage}
      </span>
      <button
        style={{
          color: isNextDisabled ? disabledColor : activeColor,
          backgroundColor: 'transparent',
          border: 'none',
          fontSize: '1.3rem',
          padding: 8,
          fontWeight: 'bold',
        }}
        onClick={onNext}
        disabled={isNextDisabled}
      >
        &#62;
      </button>
    </div>
  );
};
